import {
  ALL_LAYOUT_ARGS,
  CONTAINER_ARGS,
  getDefaultValueFromMetadata,
  pickArgs,
} from '../../../../utils/spds/metadata';
import { hash } from '@ember/helper';
import Accordion from '../accordion.gjs';
import Super from '../../core/base.gjs';
import VariableLayout from '../../layout/variable.gjs';

const METADATA = {
  component: 'Spds::Container::Group::Accordion',
  description:
    'Container for grouping multiple accordion components with consistent spacing and layout',
  meta: {
    ...ALL_LAYOUT_ARGS.meta,
    ...pickArgs(CONTAINER_ARGS, ['grid', 'reverse']).meta,
    column: {
      ...CONTAINER_ARGS.meta.column,
      defaultValue: true,
    },
    gap: {
      ...ALL_LAYOUT_ARGS.meta.gap,
      defaultValue: '0',
    },
  },
  name: 'Accordion Group',
  resources: {
    figma:
      'https://www.figma.com/design/g4zf0Vkj39VcCyleokv2rl/%E2%9D%96-Air-web-components?node-id=18965-95563&m=dev',
    github:
      'https://github.com/simplepractice/ember-simplepractice/blob/staging/addon/src/components/spds/container/group/accordion.gjs',
    zeroheight: 'https://www.simplepractice.design/1d0abbc0a/p/59ce8f-accordion',
  },
};

export default class SpdsContainerGroupAccordion extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-container-group-accordion';

  constructor() {
    super(...arguments);

    this.arguments = this.composeArguments(METADATA);
  }

  get gap() {
    return this.args.gap ?? getDefaultValueFromMetadata(METADATA, 'gap');
  }

  <template>
    <VariableLayout
      @alignContent={{@alignContent}}
      @alignItems={{@alignItems}}
      @alignSelf={{@alignSelf}}
      @area={{@area}}
      @areas={{@areas}}
      @autoFlow={{@autoFlow}}
      @column={{@column}}
      @columns={{@columns}}
      @flex={{@flex}}
      @flexWrap={{@flexWrap}}
      @gap={{this.gap}}
      @grid={{@grid}}
      @gridArea={{@gridArea}}
      @gridAutoColumns={{@gridAutoColumns}}
      @gridAutoFlow={{@gridAutoFlow}}
      @gridAutoRows={{@gridAutoRows}}
      @gridColumn={{@gridColumn}}
      @gridRow={{@gridRow}}
      @gridTemplateAreas={{@gridTemplateAreas}}
      @gridTemplateColumns={{@gridTemplateColumns}}
      @gridTemplateRows={{@gridTemplateRows}}
      @id={{@id}}
      @justifyContent={{@justifyContent}}
      @justifyItems={{@justifyItems}}
      @justifySelf={{@justifySelf}}
      @order={{@order}}
      @reverse={{@reverse}}
      @row={{@row}}
      @rows={{@rows}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      class={{this.classes}}
      data-test-spds-layout-variable
      ...attributes
    >
      {{yield (hash Accordion=(component Accordion))}}
    </VariableLayout>
  </template>
}

export const ACCORDION_GROUP_METADATA = SpdsContainerGroupAccordion.metadata;
